import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostEintragCommandServiceModule } from '..';
import { PostEintragCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostEintragCommandServiceModule
  ],
  declarations: [PostEintragCommandComponent],
  exports: [PostEintragCommandComponent],

})
export class PostEintragCommandComponentModule { }
